import request from '@/utils/request'
import qs from 'qs'

// 查询文章分页数据
export function getArticlePageList(params) {
  return request({
    url: 'Admin/BackLinkArticle/getPageList',
    method: 'get',
    params
  })
}

// 根据ID，查询文章信息
export function getArticleInfo(params) {
  return request({
    url: 'Admin/BackLinkArticle/getInfo',
    method: 'get',
    params
  })
}

// 添加文章信息
export function addArticle(data) {
  return request({
    url: 'Admin/BackLinkArticle/add',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 修改文章信息
export function editArticle(data) {
  return request({
    url: 'Admin/BackLinkArticle/edit',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 修改文章状态
export function editArticleStatus(data) {
  return request({
    url: 'Admin/BackLinkArticle/editStatus',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 查询渠道分页数据
export function getArticleChannelPageList(params) {
  return request({
    url: 'Admin/ArticleChannel/getPageList',
    method: 'get',
    params
  })
}

// 根据ID，查询渠道信息
export function getArticleChannelInfo(params) {
  return request({
    url: 'Admin/ArticleChannel/getInfo',
    method: 'get',
    params
  })
}

// 添加渠道信息
export function addArticleChannel(data) {
  return request({
    url: 'Admin/ArticleChannel/add',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 修改渠道信息
export function editArticleChannel(data) {
  return request({
    url: 'Admin/ArticleChannel/edit',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 修改渠道状态
export function editArticleChannelStatus(data) {
  return request({
    url: 'Admin/ArticleChannel/editStatus',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 获取每日统计数据
export function getDailyStatsList(params) {
  return request({
    url: 'Admin/DayStatBackLinkArticle/getPageList',
    method: 'get',
    params
  })
}
